import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {Locale} from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import jaJP from 'vant/lib/locale/lang/ja-JP'
import enLocale from './en'
import zhLocale from './zh'
import jaLocal from './ja'
Vue.use(VueI18n);

const messages = {
    en: {
        ...enUS,
        ...enLocale
    },
    zh: {
        ...zhCN,
        ...zhLocale
    },
    ja: {
        ...jaJP,
        ...jaLocal
    }
}

const i18n = new VueI18n({
    locale: localStorage.lang || 'zh',
    messages,
});

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales (lang) {
    if (lang === 'en') {
        Locale.use(lang, enUS)
    } else if (lang === 'zh') {
        Locale.use(lang, zhCN)
    } else if (lang === 'ja') {
        Locale.use(lang, jaJP)
    }
}

export {i18n, vantLocales}



// WEBPACK FOOTER //
// ./src/i18n/langs/index.js